export default "/static/liconic_lpx_tiny.png";